import { request } from './request';

export const getStores = () => {
  return request('/gemini/admin/stores', 'GET');
};

export const createStore = (displayName) => {
  return request('/gemini/admin/stores', 'POST', { displayName });
};

export const deleteStore = (storeName) => {
  return request(`/gemini/admin/stores/${storeName}`, 'DELETE');
};

export const getDocuments = (storeName) => {
  return request(`/gemini/admin/stores/${storeName}/documents`, 'GET');
};

export const getDocument = (storeName, documentName) => {
  return request(`/gemini/admin/stores/${storeName}/documents/${documentName}`, 'GET');
};

export const deleteDocument = (storeName, documentName) => {
  return request(`/gemini/admin/stores/${storeName}/documents/${documentName}`, 'DELETE');
};

export const uploadRecord = (storeName, uuid) => {
  return request(`/gemini/admin/stores/${storeName}/upload`, 'POST', { uuid });
};

export const bulkUpload = (storeName, deleteOrphans = false) => {
  return request(`/gemini/admin/stores/${storeName}/bulk-upload`, 'POST', { deleteOrphans });
};

export const bulkDelete = (storeName) => {
  return request(`/gemini/admin/stores/${storeName}/bulk-delete`, 'POST');
};

export const getJobs = () => {
  return request('/gemini/admin/jobs', 'GET');
};

export const getJob = (jobId) => {
  return request(`/gemini/admin/jobs/${jobId}`, 'GET');
};

export const cancelJob = (jobId) => {
  return request(`/gemini/admin/jobs/${jobId}`, 'DELETE');
};
